// Template274: Pekín - Metro p.1 (MetroPekin.jsx)
// Cabecera, intro, caja "Cómo pagar", lista estaciones (lugar, estación, línea), sticker.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

const Template274 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;
	const comoPagarTitle = page?.texts?.[2]?.content;
	const comoPagarHtml = page?.texts?.[3]?.content;
	const sectionTitle = page?.texts?.[4]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const sticker = getImageSrc("sticker");
	const logoImage = getCanvasImageUrl("logo");
	const estaciones = Array.isArray(page?.data?.estaciones)
		? page.data.estaciones
		: [];
	const actualHeaderColor = headerBackgroundColor || "#8c1d18";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};
	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: 66,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box
				data-block-id="text-1"
				sx={{
					padding: "10px 12px",
					paddingBottom: 2.5,
					flex: 1,
					overflow: "auto",
					position: "relative",
				}}
			>
				{intro && (
					<Box component="p" sx={{ ...estiloP, marginBottom: 1.5 }}>
						{intro}
					</Box>
				)}

				{/* Cómo pagar */}
				{(comoPagarTitle || comoPagarHtml) && (
					<Box
						data-block-id="text-2"
						sx={{
							backgroundColor: "#fde1e0",
							border: "3px solid",
							borderColor: actualHeaderColor,
							borderRadius: "12px",
							padding: "10px 14px",
							fontSize: 13,
							color: "#333",
							marginBottom: 1.75,
						}}
					>
						{comoPagarTitle && (
							<Box
								component="h4"
								sx={{
									margin: 0,
									marginBottom: 1,
									fontSize: 13,
									fontWeight: 700,
									color: actualHeaderColor,
									textTransform: "uppercase",
								}}
							>
								{comoPagarTitle}
							</Box>
						)}
						{comoPagarHtml && (
							<Box
								component="ul"
								sx={{ paddingLeft: 2.5, margin: 0, lineHeight: 1.6 }}
								dangerouslySetInnerHTML={{ __html: comoPagarHtml }}
							/>
						)}
					</Box>
				)}

				{/* Estaciones por lugares */}
				{sectionTitle && (
					<Box
						component="h3"
						sx={{
							...estiloH3,
							marginBottom: 1,
							marginTop: isSmallScreen ? 0 : -1,
						}}
					>
						{sectionTitle}
					</Box>
				)}
				{estaciones.length > 0 && (
					<Box
						data-block-id="text-3"
						sx={{
							display: "flex",
							flexDirection: "column",
							gap: 1,
							marginBottom: isSmallScreen ? 1.76 : 0,
						}}
					>
						{estaciones.map((item) => (
							<Box
								key={item.lugar}
								sx={{
									backgroundColor: "#fff",
									borderRadius: "10px",
									padding: "10px 12px",
									border: "2px solid #e8e8e8",
								}}
							>
								<Box
									sx={{
										fontWeight: 700,
										fontSize: 12,
										color: actualHeaderColor,
										marginBottom: 0.5,
									}}
								>
									{item.lugar}
								</Box>
								<Box sx={{ fontSize: 12, color: "#444" }}>
									{item.estacion} — {item.linea}
								</Box>
							</Box>
						))}
					</Box>
				)}

				{sticker && (
					<Box
						component="img"
						src={sticker}
						alt=""
						sx={{
							width: isSmallScreen ? 85 : 90,
							position: "absolute",
							bottom: isSmallScreen ? 16 : 20,
							right: isSmallScreen ? 12 : 16,
						}}
					/>
				)}
			</Box>
		</Box>
	);
};

Template274.thumbnail = "/images/template-1.png";
export default Template274;
